import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { postSaveTheDate } from "../api/saveTheDate";
import { useFormSubmitGuard } from "../hooks/useFormSubmitGuard";
import HeroImagePanel from "../components/common/HeroImagePanel";
import SaveTheDateForm from "../components/saveTheDate/SaveTheDateForm";
import {
  COUPLE_NAMES_IN_PROSE,
  HERO_IMAGE_URL,
  SAVE_THE_DATE_CONTENT,
  SAVE_THE_DATE_SEAL_URL,
} from "../constants/siteContent";

export default function SaveTheDatePage() {
  const [searchParams] = useSearchParams();
  const guestInvite = searchParams.get("guest") === "1";

  const [formKey, setFormKey] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  useFormSubmitGuard(isSubmitting);

  async function handleSaveTheDateSubmit(event) {
    event.preventDefault();
    setErrorMessage(null);
    setSuccessMessage(null);

    const formData = new FormData(event.currentTarget);
    const name = String(formData.get("name") || "").trim();
    const email = String(formData.get("email") || "").trim();
    const plusOne = guestInvite && formData.get("plusOne") === "true";
    const plusOneName = plusOne ? String(formData.get("plusOneName") || "").trim() : "";
    const plusOneEmail = plusOne ? String(formData.get("plusOneEmail") || "").trim() : "";

    if (!name || !email) {
      return;
    }
    if (plusOne && (!plusOneName || !plusOneEmail)) {
      return;
    }

    setIsSubmitting(true);
    try {
      await postSaveTheDate({
        name,
        email,
        plusOne,
        ...(plusOne ? { plusOneName, plusOneEmail } : {}),
      });
      setSuccessMessage("Thank you — we will be in touch.");
      setFormKey((k) => k + 1);
    } catch (err) {
      setErrorMessage(err instanceof Error ? err.message : "Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="save-the-date-page">
      <div className="save-the-date-overlay" />
      <section className="save-the-date-content">
        <p className="save-the-date-topline" aria-label={`Wedding of ${COUPLE_NAMES_IN_PROSE}`}>
          {SAVE_THE_DATE_CONTENT.couple}
        </p>
        <h1>{SAVE_THE_DATE_CONTENT.title}</h1>
        <p>{SAVE_THE_DATE_CONTENT.description}</p>
        <div className="save-the-date-seal-wrap save-the-date-seal-wrap--stamp">
          <img
            src={SAVE_THE_DATE_SEAL_URL}
            alt="Monogram wax seal: K and M"
            className="save-the-date-seal"
            width={150}
            height={150}
            decoding="async"
          />
        </div>
        <SaveTheDateForm
          key={`${formKey}-${guestInvite ? "g" : "n"}`}
          allowPlusOne={guestInvite}
          onSubmit={handleSaveTheDateSubmit}
          submitLabel={SAVE_THE_DATE_CONTENT.submitLabel}
          isSubmitting={isSubmitting}
          errorMessage={errorMessage}
          successMessage={successMessage}
        />
      </section>
      <HeroImagePanel className="save-the-date-image" imageUrl={HERO_IMAGE_URL} />
    </main>
  );
}
